export default "__VITE_ASSET__ChUJGZPT__"